import React from 'react'
import { FormattedMessage } from 'react-intl'
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  IconButton,
  DialogActions,
  Slide
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import WarningIcon from '@material-ui/icons/Warning'
import { useStyles } from './Styles'
import { FormLoader } from '../../../../Loader/FormLoader'
import { ServiceConsumer, ServiceProvider } from '../../../../../ServiceContext'

const Transition = React.forwardRef(function Transition (props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

const DeleteService = ({
                          index, data, setData, count, setCount, handleNotificationCall,
                          handleDeleteServiceDialog, viewDeleteServiceDialog, openDeleteServiceDialog
                        }) => {
  const classes = useStyles()

  return (
    <ServiceProvider pageAction={'delete'} handleNotificationCall={handleNotificationCall}>
      <ServiceConsumer>
        {({ deleteServiceLoading, handleDeleteService }) => (
          <>
            {!!viewDeleteServiceDialog &&
            <Dialog
              keepMounted
              fullWidth
              maxWidth={'sm'}
              open={openDeleteServiceDialog}
              classes={{ paper: classes.NewOrderDialogPaper }}
              TransitionComponent={Transition}
              onClose={handleDeleteServiceDialog}
              aria-labelledby="BasicInfoDialog"
              aria-describedby="BasicInfoDialog"
            >
              <IconButton
                edge={false}
                className={classes.NewOrderDialogClose}
                color="inherit"
                aria-label="close dialog"
                onClick={handleDeleteServiceDialog}
              >
                <CloseIcon/>
              </IconButton>
              <DialogContent className={classes.NewOrderDialogContent}>
                {!!deleteServiceLoading && <FormLoader loading={true}/>}
                <Box px={4} pt={4} pb={1} className={classes.DeleteOrderWrapper}>
                  <WarningIcon className={classes.DeleteWarningIcon}/>
                  <p><FormattedMessage id='Service.DeleteMessage' values={{ title: data[index].title }}/></p>
                </Box>
              </DialogContent>
              <DialogActions className={classes.NewOrderDialogFooter}>
                <Button size="large" variant="contained" color="primary" className={classes.DeleteOrderBtn}
                        onClick={() => {
                          handleDeleteService(index, data, setData, count, setCount, handleDeleteServiceDialog)
                        }}>
                  <FormattedMessage id='Page.Action.Delete'/>
                </Button>
                <Button onClick={handleDeleteServiceDialog} color="primary">
                  <FormattedMessage id='ChangePhone.DialogActions.cancel'/>
                </Button>
              </DialogActions>
            </Dialog>
            }
          </>
        )}
      </ServiceConsumer>
    </ServiceProvider>
  )
}

export default DeleteService
